export function SecondsFormat(seconds) {
    if(!seconds) return

    var date = new Date(null);
    date.setSeconds(seconds);
    var hhmmssFormat = date.toISOString().substr(11, 8);
    return hhmmssFormat
}